export default "__VITE_ASSET__GB6dJGwy__"